module.exports = __webpack_public_path__ + "static/MailSculpt-Image-2-bdef77d71a9dad3503a2bb72cbc1fd80.jpg";